export default function AnalyticsPage() {
  return (
    <div data-testid="analytics-root" className="p-6 space-y-4">
      <h1 className="text-2xl font-semibold text-gray-900">Analytics</h1>
      <p className="text-sm text-gray-600">
        Workspace analytics and reporting are not available in this console yet.
      </p>
      <span className="inline-block rounded-full bg-amber-50 px-3 py-1 text-xs font-medium text-amber-800">
        Coming soon
      </span>
    </div>
  );
}
